export default function createLabel(fieldConfig) {
	return `${fieldConfig.label}` + (fieldConfig.required
		? ' *'
		: '');
}
